import React, { useRef, useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

import { Collapse } from '@material-ui/core';

import BusinessTask from '~/assets/BusinessTask.svg';
import EndEvent from '~/assets/EndEvent.svg';
import Gateway from '~/assets/Gateway.svg';
import Timer from '~/assets/modeler-timer.svg';
import ParallelGateway from '~/assets/ParallelGateway.svg';
import SequenceFlow from '~/assets/SequenceFlow.svg';
import ServiceTask from '~/assets/ServiceTask.svg';
import StartEvent from '~/assets/StartEvent.svg';
import SubProcess from '~/assets/SubProcess.svg';
import UserTask from '~/assets/UserTask.svg';
import { ProcessStatus, TaskStatus } from '~/components/Details/getStatus';
import useOnClickOutside from '~/pages/utils/useOnclickOutside';

import {
  Container,
  CollapseHeader,
  CollapseContent,
  SubtitleContainer,
  Subtitle,
  SubtitleImage,
  SubtitleText,
  SubtitleIcon,
  SubtitleSpan,
} from './styles';

export interface StatusSubtitleProps {
  statuses: Array<ProcessStatus | TaskStatus>;
  getStatus: (status?: string) => { image: string; name: string };
}

const FlowSubtitle: React.FC = () => {
  const [isOpened, setOpen] = useState(false);

  const collapseRef = useRef(null);

  const toggleCollapse = () => {
    setOpen(!isOpened);
  };

  useOnClickOutside(collapseRef, () => setOpen(false));

  return (
    <Container ref={collapseRef}>
      <CollapseHeader onClick={toggleCollapse}>
        <SubtitleIcon>
          <SubtitleSpan>Legenda do processo</SubtitleSpan>
          {isOpened ? (
            <MdKeyboardArrowDown size={24} />
          ) : (
            <MdKeyboardArrowUp size={24} />
          )}
        </SubtitleIcon>
      </CollapseHeader>
      <Collapse in={isOpened}>
        <CollapseContent>
          <SubtitleContainer>
            <div>
              <Subtitle>
                <SubtitleImage size="md">
                  <img src={StartEvent} alt="" />
                </SubtitleImage>
                <SubtitleText color="#43A047">
                  <span>Início da solicitação</span>
                  <p>Início da solicitação/processo.</p>
                </SubtitleText>
              </Subtitle>
              <Subtitle>
                <SubtitleImage size="md">
                  <img src={EndEvent} alt="" />
                </SubtitleImage>
                <SubtitleText color="#E53935">
                  <span>Fim da solicitação</span>
                  <p>Fim da solicitação/processo.</p>
                </SubtitleText>
              </Subtitle>
              <Subtitle>
                <SubtitleImage size="md">
                  <img src={Timer} alt="" />
                </SubtitleImage>
                <SubtitleText style={{ margin: 'none' }} color="#1E88E5">
                  <span>Prazo</span>
                  <p>Prazo para que as próximas atividades aconteçam.</p>
                </SubtitleText>
              </Subtitle>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              <Subtitle>
                <SubtitleImage size="md">
                  <img src={Gateway} alt="" />
                </SubtitleImage>
                <SubtitleText style={{ marginLeft: '28px' }} color="#FB8C00">
                  <span>Desvio único</span>
                  <p>Indicação de qual fluxo o processo deverá seguir.</p>
                </SubtitleText>
              </Subtitle>
              <Subtitle style={{ marginBottom: '4px' }}>
                <SubtitleImage
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '6px',
                  }}
                  size="md"
                >
                  <img
                    src={ParallelGateway}
                    alt=""
                    style={{ marginBottom: '8px' }}
                  />
                  <img src={SequenceFlow} alt="" />
                </SubtitleImage>
                <SubtitleText style={{ marginLeft: '28px' }} color="#1E89E6">
                  <span>Paralelismo</span>
                  <p>Realização de múltiplas tarefas.</p>
                  <span>Fluxo de mensagem</span>
                  <p>Fluxo-padrão.</p>
                </SubtitleText>
              </Subtitle>
              <Subtitle>
                <SubtitleImage>
                  <img src={UserTask} alt="" />
                </SubtitleImage>
                <SubtitleText color="#000000">
                  <span>Tarefa de usuário</span>
                  <p>
                    Atividade/tarefa realizada pelo operador com o apoio de um
                    sistema.
                  </p>
                </SubtitleText>
              </Subtitle>
            </div>
            <div>
              <Subtitle>
                <SubtitleImage>
                  <img src={ServiceTask} alt="" />
                </SubtitleImage>
                <SubtitleText color="#FB8C00">
                  <span>Tarefa de sistema</span>
                  <p>
                    Atividade/tarefa realizada por um sistema de forma
                    automática.
                  </p>
                </SubtitleText>
              </Subtitle>
              <Subtitle>
                <SubtitleImage>
                  <img src={BusinessTask} alt="" />
                </SubtitleImage>
                <SubtitleText color="#1E88E5">
                  <span>Regra de negócio</span>
                  <p>Regra que define e organiza o fluxo do processo.</p>
                </SubtitleText>
              </Subtitle>
              <Subtitle>
                <SubtitleImage>
                  <img src={SubProcess} alt="" />
                </SubtitleImage>
                <SubtitleText color="#000000">
                  <span>Subprocesso</span>
                  <p>
                    Novo conjunto de atividades relacionadas ao processo atual.
                  </p>
                </SubtitleText>
              </Subtitle>
            </div>
          </SubtitleContainer>
        </CollapseContent>
      </Collapse>
    </Container>
  );
};

export default FlowSubtitle;
